/**
 * @file src/components/ChangePasswordModal/ChangePasswordModal.tsx
 * @exports ChangePasswordModal
 * @summary Modal wrapping the change-password form. Renders the form lazily — only after the modal has been opened at least once. Uses Mantine Modal for WCAG 2.1.1-compliant close-button keyboard handling (Space and Enter both fire the close handler).
 */

import { Modal } from "@mantine/core";
import { styled } from "styled-components";
import { ChangePasswordForm } from "./ChangePasswordForm";
import { useEffect, useState } from "react";

interface ChangePasswordModalType {
	showModal: boolean;
	closeModal: () => void;
}

const ModalWrap = styled.div`
  position: relative;
  width: 419px;
  @media all and (max-width: 720px) {
    min-width: 390px;
    width: 100%;
  }
  @media all and (max-width: 550px) {
    min-width: inherit;
  }
`;

export const ChangePasswordModal = ({ showModal, closeModal }: ChangePasswordModalType) => {
	//  We want to mount ChangePasswordForm only once, and only if the modal is opened
	const [renderForm, setRenderForm] = useState(false);
	useEffect(() => {
		if (showModal) {
			setRenderForm(true);
		}
	}, [showModal]);

	return (
		<Modal
			onClose={closeModal}
			opened={showModal}
			size={550}
			styles={{ body: { padding: "0px 66px 14px" } }}
			withCloseButton
		>
			<ModalWrap>{renderForm && <ChangePasswordForm closeModal={closeModal} />}</ModalWrap>
		</Modal>
	);
};
